import { useEffect, useRef, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getProductTypeList } from "../../Admin/adminSlice";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { DownloadTableExcel } from "react-export-table-to-excel";
import DatePicker from "../../../Component/datePicker";
import DispatchOrderPrint from "../../../Component/dispatchOrderPrint";
import DispatchOrderPopup from "../../../Component/dispatchOrderPopup";
import { getOrdersList } from "../publicationSlice";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import PaginationView from "../../../Component/paginationView";
import PaginationRounded from "../../../Component/pagination";

const DispatchOrder = () => {
    const tableRef = useRef(null);
    const dispatch: Function = useDispatch<AppDispatch>();
    const [productTypeList, setProductTypeList] = useState<any>([]);
    const [productType, setProductType] = useState<any>("");
    const [startDate, setStartDate] = useState<any>(
        moment.utc(new Date()).format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState<any>(
        moment.utc(new Date()).format("YYYY-MM-DD")
    );
    const [dispatchOrderList, setDispatchOrderList] = useState<any>([]);
    const [Status, setStatus] = useState(0);
    const [show, setShow] = useState(false);
    const [orderPrintList, setOrderPrintList] = useState<any>([]);
    const [openClose, setOpenClose] = useState(false);
    const [shipmentStatusData, setShipmentStatusData] = useState<any>();
    const [isPartialDispatchWindow, setIsPartialDispatchWindow] = useState<boolean>(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    useEffect(() => {
        dispatch(
            getProductTypeList({
                callback: (res: any) => {
                    setProductTypeList(res?.data);
                },
                errorCallback: () => { },
            })
        );
    }, []);

    const onchangeProductType = (value: any) => {
        setProductType(value);
    };
    const printValidations = () => {
        let result = true;
        let indexes = dispatchOrderList?.filter((elm: any) => elm.isSelected);
        if (indexes?.length > 0) {
            result = false;
        }
        return result;
    };

    const handlePrint = (e: any) => {
        setShow(true);
    };

    const onchangeStartDate = (value: any) => {
        setStartDate(value);
    };
    const onchangeEndDate = (value: any) => {
        setEndDate(value);
    };
    const handlePrintClose = () => {
        setShow(false);
    };

    const handleSubmit = (e: any, page: number, pagePerRows: number) => {
        setPage(page);
        setRowsPerPage(pagePerRows)
        e.preventDefault();
        const postData = {
            startDate: startDate,
            endDate: endDate,
            shipmentStatus: Status,
            productTypeId: productType?._id,
            skip: page * pagePerRows,
            limit: pagePerRows
        };
        dispatch(getOrdersList({
            params: postData,
            callback: (res: any) => {
                if (res?.status === "success") {
                    setDispatchOrderList(res?.data);
                    setTotalCount(res?.data?.length || 0);
                    dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                }
            },
            errorCallback: (error: any) => {
                dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);
            }
        }))
    };
    const getData = (val: any) => {
        setStatus(val);
        const postData = {
            startDate: startDate,
            endDate: endDate,
            shipmentStatus: val,
            skip: page * rowsPerPage,
            limit: rowsPerPage
        };
        if (productType) {
            (postData as any).productTypeId = productType?._id;
        }
        setIsPartialDispatchWindow(false);
        if (val === 1 || val === 2 || val === 3) {
            setIsPartialDispatchWindow(true);
        }
        dispatch(getOrdersList({
            params: postData,
            callback: (res: any) => {
                setDispatchOrderList(res?.data);
                setTotalCount(res?.data?.length);
                dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);
            },
            errorCallback: (error: any) => {
                dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);
            }
        }))
    };
    const validations = () => {
        let valid = false;
        if (startDate === "" || endDate === "") {
            valid = true;
        }
        return valid;
    };

    const handleCheck = (data: any, index: any) => {
        let newArray = JSON.parse(JSON.stringify(dispatchOrderList));
        if (data.target.checked) {
            newArray[index]["isSelected"] = true;
            setDispatchOrderList(newArray);
            const selectedData = newArray?.filter((item: any) => item?.isSelected === true)
            setOrderPrintList(selectedData);
        } else {
            newArray[index]["isSelected"] = false;
            setDispatchOrderList(newArray);
            const selectedData = newArray?.filter((item: any) => item?.isSelected === true);
            setOrderPrintList(selectedData.length > 0 ? selectedData : []);
        }
    };

    const handleClose = (value: any) => {
        setOpenClose(false);
    };
    
    const handleEdit = (value: any) => {
        setOpenClose(true);
        setShipmentStatusData(value)
    };

    const renderTable = () => {
        return (
            <div className="mt-4">
                <AdminTable
                    tableData={dispatchOrderList ? dispatchOrderList : []}
                    pagename={"dispatchorder"}
                    tableHead={[
                        "",
                        "S.N",
                        "ORDER NO",
                        "ORDER DATE",
                        "BUYER NAME",
                        "CITY",
                        "STATE",
                        "MOBILE NUMBER",
                        "AMOUNT",
                        "DISPATCH DATE",
                        "ACTION",
                    ]}
                    handleCheck={(value: any, index: any) => handleCheck(value, index)}
                    handleEdit={(value: any) => handleEdit(value)}
                />
            </div>
        );
    };
    const renderDetailTable = () => {
        return (
            <div className="mt-4">
                <AdminTable
                    tableData={dispatchOrderList ? dispatchOrderList : []}
                    pagename={"dispatchDetaiOrder"}
                    tableHead={[
                        "S.N",
                        "ORDER NO",
                        "ORDER DATE",
                        "BUYER NAME",
                        "ADDRESS",
                        "CITY",
                        "STATE",
                        "PIN CODE",
                        "MOBILE NUMBER",
                        "Email",
                        "PRODUCTS",
                        "AMOUNT",
                        "DISPATCH DATE",
                    ]}
                />
            </div>
        );
    };
    return (
        <div className="panel-content">
            <div className="mb-4">
                <PageTitle name={"DISPATCH ORDER"} />
            </div>
            <div className="formDiv">
                <div className="bxshadow p-2 borderRadius mb-4 ">
                    <form onSubmit={(e) => { setPage(0); handleSubmit(e, 0, rowsPerPage) }}>
                        <div className="row ">
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Start Date"} isRequired />
                                <DatePicker
                                    setInputText={(value: any) => {
                                        onchangeStartDate(value);
                                    }}
                                    value={startDate}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"End Date"} isRequired />
                                <DatePicker
                                    setInputText={(value: any) => {
                                        onchangeEndDate(value);
                                    }}
                                    value={endDate}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <LabelInput labelName={"Product Type"} />
                                <DropdownWithClear
                                    labelName={"Select Product Type"}
                                    setInputText={(value: any) => onchangeProductType(value)}
                                    options={productTypeList}
                                    value={productType}
                                />
                            </div>
                            <div className="col-md-2 mx-auto mt-3">
                                <Submitbtn name={"Search"} disabled={validations()} />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="d-flex align-items-center justify-content-start mt-4 bxshadow p-2 borderRadius mb-4">
                    <div>
                        <button
                            type="button"
                            className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${Status === 0 ? "active" : "outline"}`}
                            onClick={() => getData(0)}
                        >
                            Pending
                        </button>
                        <button
                            type="button"
                            className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${Status === 1 ? "active" : "outline"}`}
                            onClick={() => getData(1)}
                        >
                            Partial Dispatched
                        </button>
                        <button
                            type="button"
                            className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${Status === 2 ? "active" : "outline"}`}
                            onClick={() => getData(2)}
                        >
                            Dispatched
                        </button>
                        <button
                            type="button"
                            className={`btn px-3 mb-md-0 mb-2 mx-md-0 mx-1 fs-6 ${Status === 3 ? "active" : "outline"}`}
                            onClick={() => getData(3)}>
                            Delievered
                        </button>
                    </div>
                    <div className="ms-auto">
                        {dispatchOrderList?.length > 0 ? (
                            <DownloadTableExcel
                                filename="users table"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                <button
                                    type="button"
                                    className="dispachprintBtn py-2 me-1"
                                >
                                    Export Details
                                </button>
                            </DownloadTableExcel>
                        ) : null}
                        {dispatchOrderList?.length > 0 ? (
                            <button
                                type="button"
                                className={`${printValidations()
                                    ? "btn btn-secondary"
                                    : "dispachprintBtn"
                                    }`}
                                disabled={printValidations()}
                                onClick={() => setShow(true)}
                            >
                                Print Details
                            </button>
                        ) : null}
                    </div>
                    <div className="d-flex align-items-center ms-auto">
                        <PaginationRounded totalCount={totalCount} handleSubmit={handleSubmit} />
                        <PaginationView tabs={[]} handleClick={() => ('')} totalCount={totalCount} handleSubmit={handleSubmit} />
                    </div>
                    <div>

                    </div>
                </div>
                <div className="bxshadow p-1 borderRadius">{renderTable()}</div>
                <div ref={tableRef} className="d-none">{renderDetailTable()}</div>
            </div>
            <DispatchOrderPrint
                open={show}
                handlePrintClose={handlePrintClose}
                data={orderPrintList?.length > 0 ? orderPrintList : null}
            />
            <DispatchOrderPopup open={openClose} handleClose={handleClose} shipmentStatusData={shipmentStatusData} isPartialDispatchWindow={isPartialDispatchWindow} startDate={startDate} endDate={endDate} Status={Status} productTypeID={productType?._id} setDispatchOrderList={setDispatchOrderList} />
        </div>
    );
};

export default DispatchOrder;
